import { gad7_catalog } from "../../../../escalas/gad7/gad7.catalog"

const gad7_values = [
    "Ningún día",
    "Varios días",
    "Más de la mitad de los días",
    "Casi todos los días"
]

function getGad7Interpretation(score) {
    if (score <= 4) return 'Ansiedad mínima'
    if (score <= 9) return 'Ansiedad leve'
    if (score <= 14) return 'Ansiedad moderada'
    return 'Ansiedad severa'
}

export default function Gad7Results({ gad7 }) {
    if (!gad7) return null

    const score = gad7.reduce((a, v) => a + v, 0)

    return (
        <div>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
                <td><strong>Puntuación total: {score} / 21</strong></td>
                <td><strong>{getGad7Interpretation(score)}</strong></td>
            </tr>
            {
                gad7_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item}</td>
                        <td>{gad7_values[gad7[index]]}</td>
                    </tr>
                ))
            }
        </div>
    )
}